import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext, /* useState, */ useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button /* , Icon */ } from 'semantic-ui-react';
import { Form } from '../../../../../../../../../form-elements/Form';
import { LabeledInput } from '../../../../../../../../../form-elements/inputs/LabeledInput';
import { ShouldRender } from '../../../../../../../../../ShouldRender';
import { Grid } from '../../../../../../../../../layout/Grid';
// import { Radio } from '../../../../../../../../../form-elements/radios/Radio';
import { Brikk } from '../../../../../../../../../Brikk';
import { Text } from '../../../../../../../../../typography';
// eslint-disable-next-line import/no-cycle
import { UserAdministrationModalContext } from '../../../../index';
import { DeleteUser } from '../../../Users/components/DeleteUser/DeleteUser';
import styles from '../../../../styles.module.scss';
// import { Services } from '../../../Services/Services';
// import { ShowMoreButton } from '../../../../../../../../../form-elements/buttons/ShowMoreButton';
import { useUpdateUser } from '../../../../../../../../../../services/admin/update-user';
import { useUserPermissions } from '../../../../../../../../../../services/user/permissions';
import { adminUserSchema } from '../../../../../../../../../../utils/validation/schemas';
import { useModal } from '../../../../../../../../../../store/modals';

export const UserForm = () => {

  const { selectedUser, setSelectedUser /* , service, setService */ } = useContext(UserAdministrationModalContext);
  // const [showMoreServices, setShowMoreServices] = useState(false);
  
  const { openModal } = useModal();
  const { checkPermission } = useUserPermissions();
  const canUpdate = checkPermission('admin-users', 'update');
  const canDelete = checkPermission('admin-users', 'delete');

  const { updateUser, isLoading } = useUpdateUser({
    onSuccess: () => {
      openModal({
        modalType: 'NotificationModal',
        modalProps: {
          type: 'success',
          description: 'updateUserSuccess',
        },
      });
    },
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty, errors },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(adminUserSchema),
    defaultValues: {
      firstName: (selectedUser && selectedUser.firstName) || '',
      lastName: (selectedUser && selectedUser.lastName) || '',
      email: (selectedUser && selectedUser.email) || '',
      phone:
        (selectedUser
          && (selectedUser.phone
            || selectedUser.mobilephone
            || selectedUser.workphone))
        || '',
    },
  });

  useEffect(() => {
    if (selectedUser) {
      reset({
        firstName: selectedUser.firstName || '',
        lastName: selectedUser.lastName || '',
        email: selectedUser.email || '',
        phone: selectedUser.phone || selectedUser.mobilephone || selectedUser.workphone || '',
      });
    }
  }, [selectedUser, reset]);

  const onSubmit = (data) => {
    updateUser({
      userId: selectedUser.id,
      userData: {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phone: data.phone,
      },
    });
  };

  return (
    <>
      <Brikk.Heading
        heading="userAdminBrikk"
      />

      {selectedUser ? (
        <Grid
          noPadding
          oneColumn
        >

          <Form
            className={styles.form}
            onSubmit={handleSubmit(onSubmit)}
          >
            <div
              className={styles.equalColumns}
            >
              <Controller
                name="firstName"
                control={control}
                render={({ field: { ref, onChange, value } }) => (
                  <LabeledInput
                    labelIntl="firstName"
                    id="first-name"
                    value={value}
                    inputRef={ref}
                    onChange={onChange}
                    hasError={!!errors.firstName}
                    readOnly={!canUpdate}
                  />
                )}
              />

              <Controller
                name="lastName"
                control={control}
                render={({ field: { ref, onChange, value } }) => (
                  <LabeledInput
                    labelIntl="lastName"
                    id="family-name"
                    value={value}
                    inputRef={ref}
                    onChange={onChange}
                    hasError={!!errors.lastName}
                    readOnly={!canUpdate}
                  />
                )}
              />
            </div>

            <Controller
              name="email"
              control={control}
              render={({ field: { ref, onChange, value } }) => (
                <LabeledInput
                  labelIntl="email"
                  id="email"
                  type="email"
                  value={value}
                  inputRef={ref}
                  onChange={onChange}
                  hasError={!!errors.email}
                  readOnly={!canUpdate}
                />
              )}
            />

            <Controller
              name="phone"
              control={control}
              render={({ field: { ref, onChange, value } }) => (
                <LabeledInput
                  labelIntl="phoneNumber"
                  id="phoneNumber"
                  value={value}
                  inputRef={ref}
                  onChange={onChange}
                  hasError={!!errors.phone}
                  readOnly={!canUpdate}
                />
              )}
            />

            {/* Uncomment once BE implementation is done*/}
            {/* <Grid
              noPadding
              oneColumn
              style={{
                gridGap: '10px',
              }}
              justifyItems="start"
            >
              <Text
                size={20}
                fontWeight={700}
              >
                Access to services
              </Text>

              <div className={styles.service}>
                <Radio
                  label="Access Control 2n"
                  toggle
                  name="accessControl2n"
                  onChange={() => {
                  }}
                />

                <Button
                  basic
                  icon
                  labelPosition="right"
                  color="primary"
                  size="small"
                  onClick={() => setService('2N Access Control')}
                >
                  <FormattedMessage id="Configure" />
                  <Icon name="pencil alternate" />
                </Button>

              </div>
              <div className={styles.service}>
                <Radio
                  label="Security AXIS"
                  toggle
                  name="securityAxis"
                  onChange={() => {
                  }}
                />
              </div>
              <Services
                showMoreServices={showMoreServices}
                setShowMoreServices={setShowMoreServices}
              />

              <ShowMoreButton
                onClick={() => setShowMoreServices(true)}
                style={{
                  justifySelf: 'flex-start',
                }}
              >
                <FormattedMessage id="More services" />
              </ShowMoreButton>
            </Grid> */}

            {canUpdate && (
              <div className={styles.formButtons}>
                <Button
                  basic
                  name="cancel-user-details"
                  disabled={isLoading}
                  onClick={() => setSelectedUser(null)}
                >
                  <FormattedMessage id="cancel" />
                </Button>
                <Button
                  primary
                  type="submit"
                  name="submit-user-details"
                  disabled={!isDirty || isLoading}
                  loading={isLoading}
                >
                  <FormattedMessage id="saveChanges" />
                </Button>
              </div>
            )}
          </Form>

          <ShouldRender condition={selectedUser && canDelete}>
            <DeleteUser />
          </ShouldRender>

        </Grid>
      ) : (
        <Text
          secondary
          center
          intl="noUserSelected"
          size={16}
        />
      )}
    </>
  );
};
